<template>
  <nav class="w-48 flex-shrink-0 overflow-y-auto text-xs pr-2 border-r border-white/20">
    <div v-if="store.loading && !store.indexLoaded" class="text-slate-400 px-2 py-4">Loading...</div>
    <div v-else-if="store.error" class="text-red-400 px-2 py-2 text-xs">{{ store.error }}</div>
    <template v-else>
      <div v-for="(entries, category) in store.navigation" :key="category" class="mb-3">
        <button
          class="w-full text-left font-semibold text-slate-300 uppercase tracking-wide px-2 py-1 flex items-center justify-between hover:text-white"
          @click="toggleCategory(category)"
        >
          <span>{{ category }}</span>
          <span class="text-slate-500">{{ openCategories.has(category) ? '▾' : '▸' }}</span>
        </button>
        <ul v-show="openCategories.has(category)" class="mt-0.5 space-y-0.5">
          <li v-for="entry in entries" :key="entry.id">
            <button
              :class="[
                'w-full text-left px-3 py-1 rounded truncate transition-colors',
                store.currentDoc?.id === entry.id
                  ? 'bg-ui-active text-white'
                  : 'text-slate-300 hover:bg-white/10 hover:text-white',
              ]"
              @click="emit('select', entry.id)"
            >
              {{ entry.title }}
            </button>
          </li>
        </ul>
      </div>
    </template>
  </nav>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useDocumentationStore } from '../../stores/documentationStore.js'

const emit = defineEmits(['select'])
const store = useDocumentationStore()

const openCategories = ref(new Set())

watch(
  () => store.navigation,
  (nav) => {
    // Auto-open all categories on first load
    for (const cat of Object.keys(nav)) openCategories.value.add(cat)
  },
  { immediate: true }
)

function toggleCategory(cat) {
  if (openCategories.value.has(cat)) openCategories.value.delete(cat)
  else openCategories.value.add(cat)
}
</script>
